import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";
import { IReloadState } from "../interfaces/limit-orders.list.model";
import { OrdersQueryParamsCollection } from "../interfaces/limit-orders-route.interface";

const intialState: IReloadState = {
	setReload: true
};

@Injectable({ providedIn: "root" })
export class OrderListReloadState extends StateService<IReloadState> {
	public constructor() {
		super(intialState);
	}

	public getOrderListReloadState$(): Observable<IReloadState> {
		return this.select((state: IReloadState) => state);
	}

	public setOrderListReloadState(state: IReloadState): void {
		this.setState(state);
	}
}

@Injectable({ providedIn: "root" })
export class OrderListQueryParamsState extends StateService<Partial<OrdersQueryParamsCollection>> {
	public constructor() {
		super(null);
	}

	public getOrderListQueryParamsState$(): Observable<Partial<OrdersQueryParamsCollection>> {
		return this.select((state: Partial<OrdersQueryParamsCollection>) => state);
	}

	public setOrderListQueryParamsState(state: Partial<OrdersQueryParamsCollection>): void {
		this.setState(state);
	}

	public resetOrderListQueryParamsState(): void {
		this.resetStateToNull();
	}
}
